// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d8c045c","667":"a41ab37e"}[chunkId] + ".chunk.js";
};